import { Component, inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AssetRulesService } from "src/app/services/asset-rules/asset-rules.service";

@Component({
	selector: "app-confirm-clear-rule",
	templateUrl: "./confirm-clear-rule.component.html",
	styleUrls: ["./confirm-clear-rule.component.scss"],
})
export class ConfirmClearRuleComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<ConfirmClearRuleComponent>,
		private assetRulesService: AssetRulesService,
	) {}

	data = inject<{ message: string; noRulesToClear: boolean }>(MAT_DIALOG_DATA);

	ngOnInit(): void {}

	confirmClearRule() {
		this.assetRulesService.confirmClearRule$.next();
		this.dialogRef.close();
	}
}
